import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { laborService } from './labor.service';
import { GET_LABOR, GET_LABOR_SUCCESS, CREATE_LABOR, CREATE_LABOR_SUCCESS, UPDATE_LABOR, UPDATE_LABOR_SUCCESS, DELETE_LABOR, DELETE_LABOR_SUCCESS, GET_BULK_LABOR, GET_BULK_LABOR_SUCCESS, REORDER_LABOR, REORDER_LABOR_SUCCESS } from './labor.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getLaborSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(laborService.getLabor, payload);
    yield put({ type: GET_LABOR_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* createLaborSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(laborService.createLabor, payload);
    yield put({ type: CREATE_LABOR_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* updateLaborSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(laborService.updateLabor, payload.id, payload.data);
    if (Array.isArray(res.data)) {
      yield put({ type: GET_LABOR_SUCCESS, payload: res.data });
    } else {
      yield put({ type: UPDATE_LABOR_SUCCESS, payload: res.data });
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* deleteLaborSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    yield call(laborService.deleteLabor, payload);
    yield put({ type: DELETE_LABOR_SUCCESS, payload });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* getBulkLaborSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(laborService.getBulkLabor, payload);
    const byTask = {};
    (res.data || []).forEach((entry) => {
      const taskId = typeof entry.task === 'object' ? entry.task._id : entry.task;
      if (!byTask[taskId]) byTask[taskId] = [];
      byTask[taskId].push(entry);
    });
    yield put({ type: GET_BULK_LABOR_SUCCESS, payload: byTask });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* reorderLaborSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(laborService.reorderLabor, payload);
    yield put({ type: REORDER_LABOR_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchLabor() {
  yield takeLatest(GET_LABOR, getLaborSaga);
  yield takeLatest(CREATE_LABOR, createLaborSaga);
  yield takeEvery(UPDATE_LABOR, updateLaborSaga);
  yield takeLatest(DELETE_LABOR, deleteLaborSaga);
  yield takeLatest(GET_BULK_LABOR, getBulkLaborSaga);
  yield takeLatest(REORDER_LABOR, reorderLaborSaga);
}
